import { Box } from '@zillow/constellation-10';
import { shimmerStyles } from '@zg-rentals/loading-components';
import type { SystemStyleObject } from '@/styled-system/types';

type BoneType = 'line' | 'chatBubble';

type BoneProps = {
  type?: BoneType;
  css?: SystemStyleObject;
};

const typeStyles: Record<BoneType, SystemStyleObject> = {
  line: {
    height: '20px',
    width: '100%',
  },
  chatBubble: {
    height: '48px',
    width: '100%',
    borderRadius: '300',
  },
};

export default function Bone({ type = 'line', css: customCss }: BoneProps) {
  return (
    <Box
      data-loading={true}
      css={{
        ...typeStyles[type],
        ...shimmerStyles,
        ...customCss,
      }}
    >
      &nbsp;
    </Box>
  );
}
